import { ValueOf } from '../types';
import type { TransformedCmsConfigItem } from './types';
import { TYPES } from './constants';
import {
    getCategoryPath,
    getContentPagePath,
    getLandingPagePath,
    getLogoMakerIdeasPath,
    getNestedSubCategoryPath,
    getSearchQueryPath,
    getStaticPagePath,
    getStorePath,
    getSubCategoryPath,
} from './items';

export const displayName = {
    [TYPES.CATEGORY]: ({ id }) => `categories.category_${id}.name`,
    [TYPES.SUB_CATEGORY]: ({ id }) => `sub_categories.sub_category_${id}.name`,
    [TYPES.NESTED_SUB_CATEGORY]: ({ id, subCategoryId }) =>
        `sub_categories.sub_category_${subCategoryId}.nested_sub_cat_${id}.name`,
    [TYPES.STORE]: () => '',
    [TYPES.FILTERED_PAGE]: ({ id }) => `sub_categories.sub_category_${id}.name`,
    [TYPES.SEARCH_QUERY]: () => '',
};

type UrlBuilder = Partial<
    Record<ValueOf<typeof TYPES>, (params: NonNullable<TransformedCmsConfigItem['urlParams']>) => string>
>;

export const urlBuilder: UrlBuilder = {
    [TYPES.CATEGORY]: ({ id, queryParams, source }) => getCategoryPath({ id, queryParams, source }),
    [TYPES.SUB_CATEGORY]: ({ id, categoryId, queryParams, source }) =>
        getSubCategoryPath({ categoryId, id, queryParams, source }),
    [TYPES.NESTED_SUB_CATEGORY]: ({ categoryId, id, subCategoryId, queryParams, source }) =>
        getNestedSubCategoryPath({ categoryId, id: subCategoryId, nestedSubCategoryId: id, queryParams, source }),
    [TYPES.STORE]: ({ slug, queryParams, source }) => getStorePath({ slug, queryParams, source }),
    [TYPES.FILTERED_SUB_CATEGORY]: ({ categoryId, id, nestedSubCategoryId, filterUid, queryParams }) =>
        getStaticPagePath({ categoryId, id, nestedSubCategoryId, filterUid, queryParams }),
    [TYPES.SEARCH_QUERY]: ({ query, id, queryParams, source }) =>
        getSearchQueryPath({ query, id, queryParams, source }),
    [TYPES.LOGO_MAKER_IDEAS]: ({ tag, tagType }) => getLogoMakerIdeasPath({ tag, tagType }),
    [TYPES.CONTENT_PAGE]: ({ slug, source }) => getContentPagePath({ slug, source }),
    [TYPES.LANDING_PAGE]: ({ slug }) => getLandingPagePath({ slug }),
    [TYPES.LINK_URL]: ({ url = '' }) => url,
};
